import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Container from '../../../utils/Container'
import Header from '../../header/Header'
import Button from '../../../elements/buttons/Button'
import Heading1 from '../../../elements/titles/Heading1'
import bgHeader from '../../../../medias/images/bg-header-contact.jpg'

function HeaderContact({ children, img }) {


    return (
        <Header
            className=" bg-cover mt-20 h-72"
            img={bgHeader}
            id="headerContact"
        >
            <div>
                <Heading1
                    theme="white"
                    classe="relative z-30 text-center"
                    size="medium"
                >
                    Vous pouvez me contacter de plusieurs façons
                </Heading1>
            </div>
        </Header>
    );
}

export default HeaderContact;